import {DateRangePicker} from "vanillajs-datepicker";
import {Datepicker} from 'vanillajs-datepicker';
import en from 'vanillajs-datepicker/locales/en-GB';
import ru from 'vanillajs-datepicker/locales/ru';
import de from 'vanillajs-datepicker/locales/de';
import tr from 'vanillajs-datepicker/locales/tr';

Object.assign(Datepicker.locales, en, tr, de, ru);

document.addEventListener('DOMContentLoaded', () => {
    const dateInputs = Array.from(document.querySelectorAll('.js-date-picker'));

    dateInputs.forEach((inputContainer) => {
        const input = inputContainer.querySelector('input');
        if (input) {
            if (input.classList.contains('plugin-datepicker-initialized')) return;
            const singlePicker = new Datepicker(input, {
                format: 'dd/mm/yyyy',
                minDate: new Date(),
                orientation: 'bottom auto',
                language: LNG,
                weekStart: 1
            });
            input.classList.add('plugin-datepicker-initialized');
        }
    });

    // For range pickers
    const rangePickers = Array.from(document.querySelectorAll('.js-date-range-picker'));
    rangePickers.forEach((container) => {
        if (container.classList.contains('plugin-date-range-picker-initialized')) return;
        const fromInputContainer = container.querySelector('.js-date-range-picker-from');
        const toInputContainer = container.querySelector('.js-date-range-picker-to');

        if (fromInputContainer && toInputContainer) {
            const fromInput = fromInputContainer.querySelector('input');
            const toInput = toInputContainer.querySelector('input');

            const rangePicker = new DateRangePicker(container, {
                inputs: [fromInput, toInput],
                format: 'dd/mm/yyyy',
                orientation: 'bottom auto',
                language: LNG,
                weekStart: 1
            });

            container.classList.add('plugin-date-range-picker-initialized');
        }
    });
});
